import { useQueryClient } from '@tanstack/react-query';
import { useStoreActions } from '~/contexts';
import { QueryKeys } from '../queryKeys';
import { useMutationState } from '../useMutationState';
export const useLinkTaxMapping = (integration)=>{
    const { api } = useStoreActions();
    const queryClient = useQueryClient();
    const { mutateAsync, isPending } = useMutationState({
        mutationFn: async (param)=>{
            let { taxUnitId, integratedId } = param;
            await api.accounting.linkTaxMapping({
                integration,
                taxUnitId,
                integratedId
            });
            await queryClient.invalidateQueries({
                queryKey: [
                    QueryKeys.SalesTaxConfig
                ]
            });
        }
    });
    return {
        linkTaxMapping: mutateAsync,
        isLoading: isPending
    };
};
